// NETSCAPE2.0 application extension with loop count 0, which makes a GIF loop forever
const LOOP_EXTENSION = [0x21, 0xff, 0x0b, ...Array.from('NETSCAPE2.0', c => c.charCodeAt(0)), 0x03, 0x01, 0x00, 0x00, 0x00]
const LOOP_MARKER = LOOP_EXTENSION.slice(0, 14)

function startsWith (bytes: Uint8Array, text: string): boolean {
  return Array.from(text).every((c, i) => bytes[i] === c.charCodeAt(0))
}

function hasLoopExtension (bytes: Uint8Array): boolean {
  for (let i = 0; i <= bytes.length - LOOP_MARKER.length; i++) {
    if (LOOP_MARKER.every((b, j) => bytes[i + j] === b)) return true
  }
  return false
}

/**
 * Returns the GIF so that it loops forever: unchanged when it already carries the loop extension, otherwise a copy
 * with the extension right after the global color table. Throws when the bytes are not a GIF.
 */
export function ensureGifLoops (bytes: Uint8Array<ArrayBuffer>): Uint8Array<ArrayBuffer> {
  if (bytes.length < 13 || !(startsWith(bytes, 'GIF87a') || startsWith(bytes, 'GIF89a'))) throw new Error('not a gif')
  const packed = bytes[10]
  const tableEnd = 13 + (packed & 0x80 ? 3 * Math.pow(2, (packed & 7) + 1) : 0)
  if (bytes.length < tableEnd) throw new Error('not a gif')
  if (hasLoopExtension(bytes)) return bytes

  const result = new Uint8Array(bytes.length + LOOP_EXTENSION.length)
  result.set(bytes.subarray(0, tableEnd))
  result.set(LOOP_EXTENSION, tableEnd)
  result.set(bytes.subarray(tableEnd), tableEnd + LOOP_EXTENSION.length)
  // extensions need the 89a version
  result.set([0x38, 0x39, 0x61], 3)
  return result
}
